import makeApi from '../client/api'

export const updatePassword = async (token, { email, new_password }) => {
  const { api } = makeApi()
  const response = await api.post(`/account-management/password-reset/${token}`, { email, new_password })

  return response
}
